// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import { rgba } from 'polished';

const S = {
  Container: styled.div`
    display: flex;
    position: relative;
  `,
  Tab: styled.div<{ isShown: boolean }>`
    height: 32px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font: 16px Noto Sans TC;
    font-weight: ${props => props.isShown ? 700 : 300};
    color: ${props => props.isShown ? '#EF8200' : '#C9C9C9'};
    padding-bottom: 3px;
    cursor: pointer;
  `,
  TabLine: styled.div`
    position: absolute;
    left: 0;
    bottom: 0;
    height: 3px;
    background-color: #EF8200;
    transition: 0.3s;
  `,
  PopUpContainer: styled.div<{ isShow: boolean }>`
    transition: .5s all;
    ${props => props.isShow ? `
    min-width: 138px;
    background: #FFFFFF;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.161);
    border-radius: 4px;
    position: absolute;
    z-index: 99;
    top: 30px;
    right: 0;
    display: block;
    `:`
    display: none;
    `}
    
  `,
  List: styled.ul`
    display: flex;
    flex-direction: column;
    padding: 4px 0;
  `,
  Item: styled.li<{ isFocus: boolean }>`
    padding: 9px 7px;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    color: #666666;
    cursor: pointer;

    &:hover {
      ${props => props.isFocus ? null : `background-color: ${rgba('#000000', 0.15)};`};
    }

    ${props => props.isFocus ? `
    background-color: #EF8200;
    color: #fff;
    ` : null};
  `,
}

export { S as default }
